import { render, staticRenderFns } from "./LotesForm.vue?vue&type=template&id=181743f5&scoped=true&"
import script from "./LotesForm.vue?vue&type=script&lang=js&"
export * from "./LotesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181743f5",
  null
  
)

export default component.exports